import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { union } from 'lodash';
import { UiState } from 'constants/ui';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { initialEntityStructure } from 'libs/utils/redux';
import { stateName } from './constants';
export const initialState = _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
  seenClosetIds: [],
  uiState: UiState.Idle,
  pricingUiState: UiState.Idle,
  checkout: {
    order: null,
    orderFetchUiState: UiState.Idle,
    orderPrepareUiState: UiState.Idle,
    activeModal: ExtraServiceCheckoutModal.None
  }
});

function setUiState(draft, uiState) {
  draft.uiState = uiState;
}

const getClosetPromotionsRequest = draft => {
  setUiState(draft, UiState.Pending);
};

const getClosetPromotionsSuccess = (draft, action) => {
  const {
    closets
  } = action.payload;
  setUiState(draft, UiState.Success);
  const ids = closets.map(_ref => {
    let {
      user
    } = _ref;
    return user.id;
  });
  draft.ids = ids;
  closets.forEach(closet => {
    draft.byId[closet.user.id] = closet;
  });
};

const getClosetPromotionsFailure = draft => {
  setUiState(draft, UiState.Failure);
};

const getPricingRequest = draft => {
  draft.pricingUiState = UiState.Pending;
};

const getPricingSuccess = (draft, action) => {
  const {
    pricing
  } = action.payload;
  draft.pricingUiState = UiState.Success;
  draft.pricing = pricing;
};

const getPricingFailure = draft => {
  draft.pricingUiState = UiState.Failure;
};

const markClosetSeen = (draft, action) => {
  const {
    userId
  } = action.payload;
  draft.seenClosetIds = union(draft.seenClosetIds, [userId]);
};

const clearSeenClosets = draft => {
  draft.seenClosetIds = [];
};

const setCheckoutModal = (draft, action) => {
  const {
    modal
  } = action.payload;
  draft.checkout.activeModal = modal;
};

const getClosetPromotionOrderRequest = draft => {
  draft.checkout.order = null;
  draft.checkout.orderFetchUiState = UiState.Pending;
  draft.checkout.orderPrepareUiState = UiState.Idle;
};

const getClosetPromotionOrderFailure = draft => {
  draft.checkout.order = null;
  draft.checkout.orderFetchUiState = UiState.Failure;
  draft.checkout.orderPrepareUiState = UiState.Idle;
};

const getClosetPromotionOrderSuccess = (draft, action) => {
  draft.checkout.order = action.payload.closetPromotionOrder;
  draft.checkout.orderFetchUiState = UiState.Success;
  draft.checkout.orderPrepareUiState = UiState.Idle;
};

const prepareClosetPromotionOrderRequest = draft => {
  draft.checkout.orderPrepareUiState = UiState.Pending;
  draft.checkout.order = null;
};

const prepareClosetPromotionOrderSuccess = (draft, action) => {
  draft.checkout.orderPrepareUiState = UiState.Success;
  draft.checkout.order = action.payload.order;
  draft.checkout.motivation = action.payload.motivation;
};

const prepareClosetPromotionOrderFailure = draft => {
  draft.checkout.orderPrepareUiState = UiState.Failure;
  draft.checkout.order = null;
};

const startPreCheckout = draft => {
  draft.checkout.activeModal = ExtraServiceCheckoutModal.PreCheckout;
};

const setClosetPromotionOrder = (draft, action) => {
  draft.checkout.order = action.payload.order;
};

const closetPromotionSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    startPreCheckout,
    setCheckoutModal,
    setClosetPromotionOrder,
    getClosetPromotionOrderRequest,
    getClosetPromotionOrderFailure,
    getClosetPromotionOrderSuccess,
    prepareClosetPromotionOrderRequest,
    prepareClosetPromotionOrderSuccess,
    prepareClosetPromotionOrderFailure,
    getClosetPromotionsRequest,
    getClosetPromotionsSuccess,
    getClosetPromotionsFailure,
    markClosetSeen,
    clearSeenClosets,
    getPricingRequest,
    getPricingSuccess,
    getPricingFailure
  }
});
export const {
  actions
} = closetPromotionSlice;
export const plug = {
  [stateName]: closetPromotionSlice.reducer
};
export default closetPromotionSlice.reducer;